import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ChainedBackend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import vars from '@/config/vars';
import CustomHttpPostBackend from './CustomHttpPostBackend';

const DEFAULT_LNG = 'he';

const initI18n = async () => {
  const lng = DEFAULT_LNG;

  let serverVersion = null;

  try {
    const res = await fetch(`${vars.request.baseUrl}/v1/translation/getLatestVersionByType`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ type: 'client' }),
    });

    const { data } = await res.json();
    const versionFromApi = data;
    serverVersion = versionFromApi ? String(versionFromApi) : null;
  } catch (err) {
    console.error('Failed to fetch translation version:', err);
  }

  i18n
    .use(initReactI18next)
    .use(ChainedBackend)
    .init({
      lng,
      fallbackLng: 'he',
      debug: false,
      backend: {
        backends: [
          LocalStorageBackend,
          CustomHttpPostBackend,
        ],
        backendOptions: [
          {
            prefix: 'locales_',
            expirationTime: 7 * 24 * 60 * 60 * 1000,
            versions: serverVersion
              ? { [lng]: serverVersion }
              : {},
          },
          {
            loadPath: `${vars.request.baseUrl}/v1/translation/getLatestByType`,
            requestPayload: {
              type: 'client',
            },
          },
        ],
      },
      interpolation: {
        escapeValue: false,
      },
    });
};

setTimeout(() => {
  initI18n();
}, 1000);

export default i18n;
